import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFieldModel } from './widgets-field.model';

export class WidgetsTimeRangeModel extends WidgetsFieldModel {
  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.TIME_RANGE;
  name: string = 'TimeRange';
  readonly badge: string = 'TR';
  type: string = 'timeRange';         // input, radio, checkbox, TimeRange

  from: string = '';            //This is Date in ISO 8601 string Format
  to: string = '';
  suffixFrom:string='';
  suffixTo:string='';
  suffixDays:string='';

  toJSON(): any {
    const extendedSpecificProperties = {
      from: this.from ? this.from : undefined,
      to: this.to ? this.to : undefined,
      suffixFrom: this.suffixFrom ? this.suffixFrom : undefined,
      suffixTo: this.suffixTo ? this.suffixTo : undefined,
      suffixDays: this.suffixDays ? this.suffixDays : undefined,
    };

    return { ...super.toJSON(), ...extendedSpecificProperties };
  }

  /**
   * Clone from a provided origin.
   *
   * @note Id/uuid is not cloned
   * @note Without children.
   * @param origin
   * @returns
   */
  cloneFrom(origin: WidgetsTimeRangeModel): WidgetsTimeRangeModel {
    // Clone base class 
    super.cloneFrom(origin);

    if (origin.from) {
      this.from = origin.from;
    }
    if (origin.to) {
      this.to = origin.to;
    }
    if (origin.suffixFrom) {
      this.suffixFrom = origin.suffixFrom;
    }
    if (origin.suffixTo) {
      this.suffixTo = origin.suffixTo;
    }
    if (origin.suffixDays) {
      this.suffixDays = origin.suffixDays;
    }

    return this;
  }
}
